/**
 * @generated SignedSource<<328ae49a59df365d68bdbb1be733ef77>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_jiraViewResult$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle" | "ui_issueTableGroupByDropdown_GroupByDropdown">;
  readonly " $fragmentType": "main_issueNavigator_Header_jiraViewResult";
};
export type main_issueNavigator_Header_jiraViewResult$key = {
  readonly " $data"?: main_issueNavigator_Header_jiraViewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_jiraViewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_jiraViewResult",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
        },
        {
          "kind": "FragmentSpread",
          "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
        },
        {
          "kind": "FragmentSpread",
          "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};

(node as any).hash = "6801cba100b3ce72ddc57445b1e0465b";

export default node;
